export const EditDialogModes = {
  EditName: "editName",
  EditProductManager: "editProductManager",
} as const

export const CreateMode = {
  Create: "create",
} as const

// ✅ Combine them into a single DialogModes object
export const DialogModes = {
  ...EditDialogModes,
  ...CreateMode,
} as const

// ✅ Derive a union type of all possible values
export type DialogMode = (typeof DialogModes)[keyof typeof DialogModes]
export type EditDialogMode = (typeof EditDialogModes)[keyof typeof EditDialogModes]
